import { render } from "./MainStandalone.vue?vue&type=template&id=3a1e3868"
import script from "./MainStandalone.vue?vue&type=script&lang=js"
export * from "./MainStandalone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__